var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-input", {
    attrs: { value: _vm.value, disabled: _vm.disabled },
    on: { input: _vm.onInput }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }